import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { BOOKING_URL } from "@/constants/urls";

interface PricingOption {
  title: string;
  price: string;
  duration: string;
  description: string;
  featured?: boolean;
}

const PricingSection: React.FC = () => {
  const pricingOptions: PricingOption[] = [
    {
      title: "Initial Treatment",
      price: "$160",
      duration: "1-1.5 hours",
      description: "Comprehensive assessment and your first treatment session to address your health concerns and develop a personalised plan."
    },
    {
      title: "Follow-up Appointment",
      price: "$110",
      duration: "1 hour",
      description: "Ongoing care to monitor progress, adjust your treatment plan as needed, and continue supporting your health journey.",
      featured: true
    }
  ];

  return (
    <section id="pricing" className="section-padding bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">Our Pricing</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Transparent pricing for your wellness journey with options to suit your needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {pricingOptions.map((option, index) => (
            <Card 
              key={index} 
              className={`overflow-hidden rounded-2xl shadow-lg border-4 border-amber-200/30 card-hover ${option.featured ? 'ring-1 ring-sage-500/20' : ''}`}
            >
              <CardHeader>
                <CardTitle className="text-2xl font-serif text-sage-800">{option.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="mb-4">
                  <p className="text-3xl font-bold text-sage-700">{option.price}</p>
                  <p className="text-gray-600">{option.duration}</p>
                </div>
                <p className="text-gray-700">{option.description}</p>
              </CardContent>
              <CardFooter>
                <Button 
                  className={option.featured ? "btn-primary w-full" : "btn-outline w-full"}
                  asChild
                >
                  <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-amber-600 hover:bg-amber-700 text-white ml-2 px-4 py-2 rounded-md"
                  >
                    Book Now
                  </a>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 italic">
            Health fund rebates may be available depending on your level of cover.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
